/* ==========================================================================
   CYRIELLE — Theme JS
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {

  /* ---------- Cart Drawer ---------- */
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-overlay');
  const cartTriggers = document.querySelectorAll('[data-cart-toggle]');
  const cartClose = document.querySelector('.cart-close');

  const openCart = () => {
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  const closeCart = () => {
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  };

  cartTriggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

/* ---------- Mega Menu (click toggle) ---------- */
const megaTriggers = document.querySelectorAll('[data-mega-trigger]');
const megaBackdrop = document.querySelector('[data-mega-backdrop]');

const closeAllMega = () => {
  document.querySelectorAll('.mega-menu.open').forEach(m => m.classList.remove('open'));
  document.querySelectorAll('[data-mega-trigger]').forEach(t => t.setAttribute('aria-expanded', 'false'));
  if (megaBackdrop) megaBackdrop.classList.remove('open');
};

megaTriggers.forEach(trigger => {
  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    const id = trigger.dataset.megaTrigger;
    const panel = document.querySelector(`[data-mega-panel="${id}"]`);
    const isOpen = panel.classList.contains('open');

    closeAllMega();

    if (!isOpen) {
      panel.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
      if (megaBackdrop) megaBackdrop.classList.add('open');
    }
  });
});

if (megaBackdrop) megaBackdrop.addEventListener('click', closeAllMega);
document.addEventListener('click', (e) => {
  if (!e.target.closest('.nav-item')) closeAllMega();
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeAllMega();
});

  /* ---------- Color Swatches ---------- */
  document.querySelectorAll('[data-swatch-group]').forEach(group => {
    const swatches = group.querySelectorAll('.swatch');
    swatches.forEach(s => {
      s.addEventListener('click', () => {
        swatches.forEach(x => x.classList.remove('active'));
        s.classList.add('active');
        const colorLabel = group.parentElement.querySelector('[data-color-name]');
        if (colorLabel) colorLabel.textContent = s.dataset.color;

        // Update primary image if data-image present
        const img = s.dataset.image;
        const primary = document.querySelector('[data-primary-image]');
        if (img && primary) primary.src = img;
      });
    });
  });

  /* ---------- Size Selector ---------- */
  document.querySelectorAll('[data-size-group]').forEach(group => {
    const buttons = group.querySelectorAll('.size-btn');
    buttons.forEach(b => {
      b.addEventListener('click', () => {
        if (b.disabled) return;
        buttons.forEach(x => x.classList.remove('active'));
        b.classList.add('active');
      });
    });
  });

  /* ---------- Add to Cart (Shopify AJAX) ---------- */
  const addBtn = document.querySelector('[data-add-to-cart]');
  if (addBtn) {
    addBtn.addEventListener('click', async () => {
      const variantId = addBtn.dataset.variantId;
      const activeSize = document.querySelector('.size-btn.active');
      if (!activeSize) {
        alert('Please select a size');
        return;
      }
      addBtn.textContent = 'Adding...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: activeSize.dataset.variantId || variantId,
            quantity: 1
          })
        });
        if (res.ok) {
          addBtn.textContent = 'Added ✓';
          setTimeout(() => {
            addBtn.textContent = 'Add to Bag';
            openCart();
            refreshCart();
          }, 800);
        }
      } catch (err) {
        addBtn.textContent = 'Try again';
      }
    });
  }

  /* ---------- Refresh cart contents ---------- */
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(el => el.textContent = cart.item_count);
    } catch (e) {}
  }
  refreshCart();

  /* ---------- Mobile menu ---------- */
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
    });
  }

  /* ---------- Scroll fade reveal ---------- */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));

/* ---------- Newsletter ---------- */
const newsletter = document.querySelector('[data-newsletter]');
if (newsletter) {
  newsletter.addEventListener('submit', () => {
    localStorage.setItem('cyrielleEarlyAccess', 'true');
  });
}

});


document.addEventListener('touchstart', function(e){
  const media = e.target.closest('.product-card-media');
  const tile = e.target.closest('.tile');

  if (media && media.querySelector('.img-hover')) {
    media.classList.add('is-touch-preview');
  }

  if (tile && tile.querySelector('.tile-img-hover')) {
    tile.classList.add('is-touch-preview');
  }
}, { passive: true });

document.addEventListener('touchend', function(){
  setTimeout(function(){
    document.querySelectorAll('.is-touch-preview').forEach(function(el){
      el.classList.remove('is-touch-preview');
    });
  }, 350);
}, { passive: true });

document.addEventListener('touchcancel', function(){
  document.querySelectorAll('.is-touch-preview').forEach(function(el){
    el.classList.remove('is-touch-preview');
  });
}, { passive: true });

